
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "IAPOMVFCND",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/IAPOMVFCND.vue